import React, { useEffect } from "react";
import "./StarsBackground.css"; // Importa el archivo de estilos

const StarsBackground = () => {
  useEffect(() => {
    const starContainer = document.querySelector(".stars");
    if (!starContainer) return;

    for (let i = 0; i < 100; i++) {
      let star = document.createElement("div");
      star.classList.add("star");
      star.style.top = Math.random() * 100 + "vh";
      star.style.left = Math.random() * 100 + "vw";
      star.style.animationDuration = (Math.random() * 3 + 2) + "s";
      star.style.animationDelay = Math.random() * 5 + "s";
      starContainer.appendChild(star);
    }
  }, []); // Se ejecuta solo una vez al montar el componente

  return <div className="stars"></div>;
};

export default StarsBackground;